
(function imagesJs($, Drupal) {
  Drupal.behaviors.imagesJs = {
    attach(context) {
      // Go through media embeds, and alter well width to match caption size.
      $('[id^="med-emb_"]').each(function () {
        const imgSize = $(this).find('img').width();
        if (imgSize !== 0) {
          $(this).parent('figure').css('max-width', imgSize);
        }
      });
    },
  };
}(jQuery, Drupal));

// Ticket - NOAA-6304 - Follow-up re: Deleting and Unpublishing Images from Drupal Media
// NOAA-6304 - For future images that load, handle this
jQuery('img').on('error', function () {
  // The following will delete the image-captions after images that fail to load
  jQuery(this).next('.webdam-embed-caption, .dam_caption').hide();
});

